import Model  from '@/util/models';

export default class Assignment extends Model { 
    backend = '/rbac/assignment/'; 
   
    assign(items, params){                        
        return this.api.post(this.backend + 'assign', items, params); 
    }    
    
    remove(items, params){                        
        return this.api.post(this.backend + 'revoke', items, params); 
    }  
    
    view(params){                        
        return this.api.post(this.backend + 'view', {}, params); 
    }  
}

